import { createFileRoute } from '@tanstack/react-router'
import { Dashboard } from '@/features/dashboard'

export const Route = createFileRoute('/_layout/_app/dashboard')({
  component: Dashboard,
  staticData: { title: 'Izteki pogodb' },
})
